module.exports = __webpack_public_path__ + "static/media/luis.d0db90af.jpeg";